import { RouterPath } from 'constants/constants';
import urlParse from 'url';
import { getAccount } from 'utils/businesslog';
import { marketMenu } from '@/modules/Market/MarketMenu/confg';

interface UrlObj {
    page?: string;
    params?: any;
}

interface UrlMapFnParam {
    url?: string | UrlObj;
    page?: string;
    params?: any;
}

export const commonPVMap = ({ url, page, params }: UrlMapFnParam): UrlObj => {
    let matchPage: string;
    let sendParams: any;

    const accountInfo = getAccount();
    const { pathname, query } = urlParse.parse(String(url), true);

    const isInThemeArea = (pathname: string) => {
        return marketMenu.find((themeConfig) => pathname === themeConfig?.path);
    };
    const matchedThemePath = isInThemeArea(pathname);

    // 标签专区首页曝光
    if (pathname.includes('/population/tags-area')) {
        matchPage = 'DMP_LABEL_SHOW';
    } else if (pathname === RouterPath.MY_POPULATION_PATH) {
        // 人群管理页面曝光
        matchPage = 'DMP_POP_SHOW';
    } else if (pathname.includes('/portrait')) {
        // 人群洞察页面曝光 默认上报人群洞察页面的 source 值，其它入口将在跳转时加入 source
        matchPage = 'DMP_WANGXIANG_ANALYSE';
        sendParams = {
            source: 4,
            pop_id: query?.orientationId || 0,
        };
    } else if (pathname.includes('/crowd-chart')) {
        // 投放报表页面曝光
        matchPage = 'DMP_REPORT_SHOW';
        sendParams = {
            source: 1,
        };
    } else if (pathname.includes('/report/insights-taglist')) {
        // 标签榜单页面曝光
        matchPage = 'MY_LABEL_LIST';
        // 标签榜单页默认上报点击效果榜单+地域模块曝光
        sendParams = {
            tab: 1,
            tab_level2: 1,
        };
    } else if (pathname.includes('/feature')) {
        // 功能动态曝光
        matchPage = 'DMP_OTHERS';
        sendParams = {
            source: 1,
            tab: 2,
        };
    } else if (pathname === '/account-compass') {
        // 账号列表页曝光
        matchPage = 'DMP_ACCOUNT_LIST_SHOW';
    } else if (pathname === '/logic-diagram') {
        // 运算人群页面曝光
        matchPage = 'DMP_POP_COMBINATION_SHOW';
    } else if (pathname === '/population/create') {
        // 人群管理页面新建人群曝光
        matchPage = 'DMP_POP_MANAGE_CREATE_SHOW';
    } else if (pathname === '/') {
        // 首页曝光
        let status;
        if (accountInfo?.accountId) {
            status = 1;
        } else {
            status = 0;
        }
        matchPage = 'DMP_HOME_PAGE_SHOW';
        sendParams = {
            status,
        };
    } else if (matchedThemePath) {
        // 主题专区曝光
        matchPage = 'DMP_THEME_AREA';
        sendParams = { page_type: matchedThemePath.title };
    } else if (pathname === '/market/industry_population') {
        matchPage = 'DMP_INDUSTRY_SHOW';
    } else if (pathname === '/market/common_population') {
        matchPage = 'DMP_COMMON_SHOW';
    } else if (pathname.includes('/market/props_data') && query.type === 'create') {
        // 新建数据源
        matchPage = 'DMP_CREATE_DATA_SOURCE';
    } else if (pathname.includes('/market/props_data') && query.type === 'update') {
        // 更新数据源
        matchPage = 'DMP__RENEW_DATA_SOURCE';
        //  query.type为 空
    } else if (pathname === '/market/props_data') {
        // 人群集市 - 数据源曝光
        matchPage = 'DMP_DATA_SOURCE';
    } else if (pathname === '/tools/word-pack') {
        matchPage = 'DMP_TOOLBOX_WORD';
    } else if (pathname === '/message/center') {
        // 消息中心曝光
        matchPage = 'DMP_INFO';
    } else if (pathname === '/market/special') {
        // 小店专区曝光
        matchPage = 'DMP_DIANSHANG_PAGE_SHOW';
    } else if (pathname === '/report/insights-analysis') {
        // 受众分析曝光
        matchPage = 'DMP_AUDIENCE_REPORT';
        sendParams = {
            tab: 1,
        };
    } else if (pathname === '/tools/store-pack') {
        // 门店管理曝光
        matchPage = 'DMP_TOOLBOX_STORE';
    } else if (pathname === '/market/feature') {
        // 三方精选曝光
        matchPage = 'DMP_SANFNG_SHOW';
    } else if (pathname === '/population-optimize') {
        // 人群优化曝光
        matchPage = 'DMP_POP_OPTIMAZATION_SHOW';
    } else if (pathname === '/policys/population-optimize/intelligence-selection') {
        // 人群优化-智能优选页面曝光
        matchPage = 'DMP_INTELLIGENCE_SELECTION_SHOW';
    } else if (pathname.includes('/split-deduplicate')) {
        matchPage = 'SPLIT_DEDUPLICATE';
    } else if (pathname === '/population') {
        matchPage = 'MY_POPULATION';
    } else if (pathname === '/recommend') {
        matchPage = 'DMP_SHOUYE';
        sendParams = {
            second_industry_name: localStorage.getItem('secondIndustryName'),
        };
        // 策略中心 - 人群诊断页面曝光
    } else if (pathname === '/policys/lead_library') {
        matchPage = 'DMP_CLUE_ANALYSE_TAB';
    } else if (pathname === '/tools/word-pack-manage') {
        // 关键词推荐曝光
        matchPage = 'DMP_KEYWORD_RECOMMEND';
    } else if (pathname === '/tools/encryption') {
        // 加密工具曝光
        matchPage = 'DMP_ENCRYPTION_TOOLS';
    } else if (pathname === '/tools/population-sync') {
        // 人群列表同步曝光
        matchPage = 'DMP_GROUP_LIST_PUSH';
    } else if (pathname === '/report/industry-taglist') {
        // 行业榜单曝光
        matchPage = 'DMP_INDUSTRY_LABEL_LIST';
        sendParams = {
            tab: 1,
        };
    } else if (pathname === '/analysis-center/advertise-analysis/list') {
        // 投广分析列表页
        matchPage = 'DMP_TG_ANALYSE_LIST';
        sendParams = {
            second_industry_name: localStorage.getItem('secondIndustryName'),
        };
    } else if (pathname === '/analysis-center/advertise-analysis/report') {
        matchPage = 'DMP_TG_ANALYSE';
        sendParams = {
            second_industry_name: localStorage.getItem('secondIndustryName'),
            report_id: query?.reportId,
            report_name: query?.reportName,
        };
    }
    return {
        page: matchPage,
        params: {
            ...sendParams,
            ...params,
            account_id: accountInfo?.accountId,
            app_id: localStorage.getItem('appId'),
        },
    };
};
